/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-on-calls-in-components */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable ember/no-jquery */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import $ from 'jquery';
import { schedule } from '@ember/runloop';
import { computed } from '@ember/object';
import { or, not, readOnly } from '@ember/object/computed';
import { on } from '@ember/object/evented';
import Component from '@ember/component';
import { action } from '@ember/object';
export default Component.extend({
  mode: 'default',
  setupDefaults: on('init', function () {
    this.set('comparisonOptions', this.predicate.getComparisonOptions({
      mode: this.mode
    }));
  }),
  didInsertElement() {
    this._super(...arguments);
    this._focusCorrectInput();
  },
  predicateShouldDisplayAsValid: or('predicate.isValid', 'forceDisplayAsValid'),
  predicateShouldDisplayAsInvalid: not('predicateShouldDisplayAsValid'),
  fieldClasses: computed('predicateShouldDisplayAsInvalid', function () {
    return `f__text${this.predicateShouldDisplayAsInvalid ? ' o__error' : ''}`;
  }),
  hideValueInput: readOnly('predicate.isNotValueBasedComparison'),
  _focusCorrectInput() {
    schedule('afterRender', this, () => {
      if (!this.isDestroying) {
        $('.f__text', this.element).focus();
      }
    });
  },
  handleKeyUp: action(function (event) {
    if (event.keyCode === 13) {
      this.onComplete();
    }
  }),
  actions: {
    focusInputAndChangePredicateComparison(comparison) {
      this._focusCorrectInput();
      this.changePredicateComparison(comparison);
    }
  }
});